import { EventName } from '@/constants/mixpanel'
import { trackEvent } from '@/utils/mixpanelClient'

export const createDialogAnalytics = (title?: string, key?: string) => {
  // ダイアログを開くイベントを追跡
  const trackOpen = () => {
    trackEvent(EventName.DialogOpened, {
      dialog_title: title || 'Untitled Dialog',
      dialog_key: key,
    })
  }

  // ダイアログを閉じるイベントを追跡
  const trackClose = () => {
    trackEvent(EventName.DialogClosed, {
      dialog_title: title || 'Untitled Dialog',
      dialog_key: key,
    })
  }

  return { trackOpen, trackClose }
}

// React Component内で使用するためのhook
export const useDialogAnalytics = (title?: string, key?: string) => {
  return createDialogAnalytics(title, key)
}
